export default {

    // 当前语言
    language: 'zh-cn',

    // 当前账户数据
    accountData: JSON.parse(localStorage.getItem('accountData')),

    // 当前城市名称
    thisCityName: localStorage.getItem('thisCityName'),
}



// WEBPACK FOOTER //
// ./src/store/state.js